"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenDeep = (array) => {
    const flat = [];
    for (const item of array) {
        const values = Array.isArray(item) ? exports.flattenDeep(item) : [item];
        for (const val of values) {
            flat.push(val);
        }
    }
    return flat;
};
